import React from 'react';
import { Modal, Stack, Text, Button } from '@mantine/core';

interface SuccessModalProps {
  opened: boolean;
  onFinish: () => void;
  mode: 'newsletter_generated' | 'doi_started';
}

export const SuccessModal: React.FC<SuccessModalProps> = ({ opened, onFinish, mode }) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {
        // Absichtlich leer: Schließen über ESC oder Klick außerhalb nicht erlaubt
      }}
      title=""
      centered
      size="md"
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Stack gap="xl" align="center">
        <Text size="lg" ta="center" fw={600}>
          {mode === 'newsletter_generated'
            ? 'Ihr Newsletter wird erstellt!'
            : 'Vielen Dank für Ihre Anmeldung!'}
        </Text>

        {mode === 'newsletter_generated' ? (
          <>
            <Text size="md" ta="center" c="dimmed">
              Unsere KI stellt gerade Ihren persönlichen Newsletter zusammen – individuell auf Sie
              zugeschnitten.
            </Text>

            <Text size="md" ta="center" c="dimmed">
              Sie erhalten ihn in Kürze per E-Mail. Dieser Vorgang kann ein paar Minuten dauern.
            </Text>
          </>
        ) : (
          <>
            <Text size="md" ta="center" c="dimmed">
              Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Bitte klicken Sie auf den
              Bestätigungslink in der E-Mail.
            </Text>

            <Text size="md" ta="center" c="dimmed">
              Sobald Sie Ihre E-Mail-Adresse bestätigt haben, generiert unsere KI automatisch Ihren
              persönlichen Newsletter und sendet ihn an Sie.
            </Text>

            <Text size="sm" ta="center" c="dimmed" fs="italic">
              Falls Sie keine E-Mail erhalten haben, prüfen Sie bitte auch Ihren Spam-Ordner.
            </Text>
          </>
        )}

        <Text size="md" ta="center" c="dimmed">
          Wir freuen uns über Ihr{' '}
          <Text
            component="a"
            href="https://forms.office.com/pages/responsepage.aspx?id=wluSDcsxCkKjXiW8m8X8vajr0sfbwL1NjNiYbK8v1jZUNlFEVkZPMjdERVVEU09NMTFVRzQwTVBKWS4u&route=shorturl"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#667eea',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Feedback
          </Text>{' '}
          zu unserem Newsletter-Service!
        </Text>

        <Button
          onClick={onFinish}
          size="md"
          fullWidth
          mt="xl"
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none'
          }}
        >
          Beenden
        </Button>
      </Stack>
    </Modal>
  );
};
